var n;!function(n){n.Spanish="es",n.English="en"}(n||(n={}));const i=[{id:n.Spanish,name:"Español"},{id:n.English,name:"English"}],s=[n.Spanish,n.English];export{s as ENABLED_LOCALES,i as LOCALES,n as Language};
